import React,{useState,useEffect,useRef} from 'react'
import Countdown from 'react-countdown'
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import '../inc/GlobalVars';
import   submitBid   from "../inc/hooks/submitBid";
function MyBidsComp(props) {

  const bidId = useRef(null);
  const user_id = localStorage.getItem('userId'); 
const bidNow = (vehicleId) => {
  bidId.current.value = vehicleId;
};
    const renderer = ({hours,minutes,seconds}) => {
        return(
            <div>
                <span className="time">{hours}</span>
                <span>:</span>
                <span className="time">{minutes}</span>
                <span>:</span>
                <span className="time">{seconds}</span>
                
            </div>
        )
    }
    const data = { bid_amount:""}
const [inputData, setInputData] = useState(data);

const handleData = (e) =>
{
    setInputData({...inputData,[e.target.name]:e.target.value});
}
const handleBidding = async(e) => {
  e.preventDefault();
  var da= {bid_amount:inputData.bid_amount,userId:user_id,vehicle_id:bidId.current.value}
  
  const bid_amount = inputData.bid_amount;
  const vehicleId = bidId.current.value; // Get vehicle ID from form
  await submitBid(bid_amount, vehicleId);
}

  return (
    <div className='container auction-list-card mt-2'>
       <ToastContainer
position="top-left"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="colored"
/>
        <div className='row d-flex justify-content-center align-items-center'>
            <div className='col-md-4 position-relative'>
            <span className={props.bid_status == 1 ? "text-white bid-status-loosing" : "text-white bid-status-win"} style={{fontWeight:"bold"}}>{props.bid_status == 1 ? "Losing" : "Winning"}</span>
            <img
              src={global.apiUrl +"/"+props.featured_image}
              className="img-fluid carCarImage"
            />
            </div>

            <div className='col-md-8'>
            <div className='carCard'>
            <h3 style={{textTransform:"capitalize"}}>{props.make_name+" "+props.model}</h3>
            <ul className="list-group">
              <li className="list-group-item  d-flex justify-content-between align-items-center">
                <span className="">Registration Number</span>
                <span className="" style={{textTransform:"uppercase"}} >{props.reg_number}</span>
              </li>
              
              <li className="list-group-item  d-flex justify-content-between align-items-center">
                <span className="">Fuel Type</span>
                <span className="">Pertrol/CNG</span>
              </li>
              <li className="list-group-item  d-flex justify-content-between align-items-center">
                <span className="">My Bid</span>
                <span className="auction-min-bid">&#8377; {props.bid_amount}</span>
              </li>
            </ul>
                
                </div>
                <div className="col-md-12" style={{flex:"1"}}>
                <button onClick={() => bidNow(props.vehicle_id)} value={props.vehicle_id} data-bs-toggle="modal" data-bs-target={"#exampleModal"+props.vehicle_id} className="btn btn-primary carCardButton">BID NOW</button>
            </div>
            </div>
        </div>
        <div className='row'>
          <div className="col-md-12 mt-3">
            <ul className="list-group">
            <li className="list-group-item  d-flex align-items-center">
                <p className='p-0 m-0'>All the extra accessories, fitted by insurer, can be removed by him at the time of lifting</p>
              </li>
              <li className="list-group-item  d-flex align-items-center">
                <p className='p-0 m-0'>Request would not be entertained at the time of lifting of the vehicle post approval to any vehicle missing parts and/or parking charges(if any)</p>
              </li>
            </ul>
          </div>
        </div>


        <div className="modal fade" id={"exampleModal"+props.vehicle_id} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content" style={{background:"#edfbfb"}}>
      <div className="modal-header p-0 m-0" >
        <img src={global.apiUrl +"/"+props.featured_image} className="img-fluid" />
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" style={{position: "absolute",
    right: "-7px",
    color: "#fff",
    top: "-4px",
    filter: "invert(1)"}}></button>
      </div>
      <div className="modal-body">
        <form method="POST" encType="multipart/form-data">
          <input type="hidden" name="user_id" value={user_id} />
          <input type="hidden" name="vehicle_id" ref={bidId} />
          <h3 style={{textTransform:"capitalize",textAlign:"center"}}>{props.make_name+" "+props.model}</h3>
            <ul className="list-group">
              <li className="list-group-item  d-flex justify-content-between align-items-center">
              <span className="">Registration Number</span>
                <span className="" style={{textTransform:"uppercase"}}>{props.reg_number}</span>
                
              </li>
              <li className="list-group-item  d-flex justify-content-between align-items-center">
              <span className="">Case Type</span>
                <span className="" style={{textTransform:"capitalize"}}>{props.case_name}</span>
                
              </li>
            </ul>
          <div className="mb-2 mt-4  input-wrapper">
            <label>Bid Amount <span className="text-danger">*</span></label>
            <input type="text" className="form-control"  value={inputData.bid_amount} onChange={handleData} placeholder="Enter Bid Amount" name="bid_amount" required />
          </div>
          <div className="mt-3">
            <button type="submit" onClick={handleBidding} className="btn btn-primary carCardButton" >Submit Now</button>
          </div>
          </form>
      </div>
      
    </div>
  </div>
</div>
    </div>
  )
}

export default MyBidsComp